<template>
  <div class="login-page">
    <!-- 登录卡片 -->
    <div class="login-card">
      <!-- Logo + 品牌名 -->
      <div class="brand-header">
        <div class="brand-logo-circle">佩</div>
        <span class="brand-text">升前研</span>
      </div>

      <!-- 标题区 -->
      <div class="form-header">
        <h2 class="form-title">{{ formTitle }}</h2>
        <p class="form-subtitle">{{ formSubtitle }}</p>
      </div>

      <!-- 表单插槽 -->
      <slot/>
    </div>

    <!-- 底部版权（视觉隐藏，保留DOM供爬虫抓取ICP备案） -->
    <div class="login-footer sr-only" aria-hidden="false">
      <div class="copyright">
        Copyright© {{ year }} 广州市佩升前研市场信息咨询有限公司, all rights reserved |
        <a href="https://beian.miit.gov.cn" target="_blank" rel="nofollow">粤ICP备13010661号</a>
      </div>
    </div>

    <!-- 遮罩层 - 覆盖右下角水印 -->
    <div class="watermark-cover"></div>
  </div>
</template>

<script>
import { getYear, addClass, removeClass } from '@/utils'
export default {
  name: 'LoginLayout',

  props: {
    title: {
      type: String,
      default: '登录'
    }
  },

  computed: {
    formTitle() {
      switch (this.title) {
        case '登录': return '欢迎登录'
        case '重置密码': return '重置密码'
        case '找回密码': return '找回密码'
        default: return '欢迎登录'
      }
    },
    formSubtitle() {
      switch (this.title) {
        case '登录': return '请使用您的账号登录系统'
        case '重置密码': return '请设置您的新密码'
        case '找回密码': return '请输入您的注册邮箱以找回密码'
        default: return '请使用您的账号登录系统'
      }
    }
  },

  data () {
    return {
      year: getYear()
    }
  },

  created () {
    addClass(document.body, 'login-page-body')
  },

  beforeDestroy () {
    removeClass(document.body, 'login-page-body')
  }
}
</script>

<style lang="scss">
/* 全局body样式 */
.login-page-body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background: #f8fafc;
  overflow: hidden;
  font-family: 'Inter', "Microsoft YaHei", -apple-system, sans-serif;
}

/* 链接样式 */
a {
  color: #5a6a85;
  text-decoration: none !important;
  &:hover {
    color: #1476ff;
  }
}

/* ========== 页面容器 ========== */
.login-page {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 16px;
  box-sizing: border-box;
}

/* ========== 登录卡片 ========== */
.login-card {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 440px;
  background: white;
  border-radius: 16px;
  padding: 32px 40px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  border: 1px solid #e2e8f0;
}

/* ========== Logo + 品牌名 ========== */
.brand-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 32px;
}

.brand-logo-circle {
  width: 42px;
  height: 42px;
  background: #e53935;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;
}

.brand-text {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 1px;
}

/* ========== 标题区 ========== */
.form-header {
  text-align: center;
  margin-bottom: 36px;
}

.form-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px;
}

.form-subtitle {
  color: #64748b;
  font-size: 14px;
  margin: 0;
}

/* ========== 底部版权 ========== */
.login-footer {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 20;

  .copyright {
    font-size: 12px;
    color: #94a3b8;
  }
}

/* 遮罩层 - 覆盖右下角水印 */
.watermark-cover {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 120px;
  height: 40px;
  background: #f8fafc;
  z-index: 5;
}

/* ========== 爬虫可见但视觉隐藏 ========== */
.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

/* ========== 响应式适配 ========== */
@media (max-width: 480px) {
  .login-card {
    padding: 24px 20px;
    border-radius: 12px;
  }
}
</style>
